
// ModalContasApagar.js

import React, { useState, useEffect, useCallback } from 'react';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import './ModalContasAreceber.css';

function ModalCriarParcelasCompra({ isOpen, fecharModal, codCompra, valCompra, dadosCompra }) {
  const [quantidadeParcelas, setQuantidadeParcelas] = useState(1);
  const [parcelas, setParcelas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [parcelasExistentes, setParcelasExistentes] = useState([]);
  const [valorCompra, setValorCompra] = useState(0); // Aqui, capturamos o valor da compra do backend.
  
  const fetchParcelasExistentes = useCallback(() => {
    api.get(`/apagar/${codCompra}/apagar`)
  
      .then(response => {
        setParcelasExistentes(response.data);
        setParcelas(response.data);
      })
      .catch(error => {
        console.error('Erro ao buscar parcelas existentes:', error);
      });
  }, [codCompra]);

  // Nova função para buscar o valor da compra pelo codCompra.
  const fetchValorCompra = useCallback(() => {
    api.get(`/compras/buscarcompra?codcompra=${codCompra}`)
      
      .then(response => {
        if (response.data && response.data.valcompra) {
          setValorCompra(response.data.valcompra);
        } else {
          console.error('Erro: Valor da compra não encontrado.');
        }
      })
      .catch(error => {
        console.error('Erro ao buscar valor da compra:', error);
      });
  }, [codCompra]);

  useEffect(() => {
    if (isOpen) {
      fetchParcelasExistentes();
      fetchValorCompra(); // Buscando o valor da compra ao abrir o modal
    }
  }, [isOpen, fetchParcelasExistentes, fetchValorCompra]);

  const gerarParcelas = () => {
    if (valorCompra > 0) {
      const novasParcelas = [];
      const valorParcela = valorCompra / quantidadeParcelas;

      for (let i = 1; i <= quantidadeParcelas; i++) {
        //const dtvencimento = new Date();
        const dtvencimento = new Date(dadosCompra.dtcompra); // Converter `dtcompra` para Date
        dtvencimento.setMonth(dtvencimento.getMonth() + i);

        novasParcelas.push({
          parcela: i,
          dtvencimento: dtvencimento.toISOString().split('T')[0],
          valparcela: valorParcela,
        });
      }

      setParcelas(novasParcelas);
    } else {
      console.error('Valor da compra é 0 ou não foi carregado corretamente');
    }
  };


  const handleSave = () => {
    setLoading(true);
    const dadosParcelas = parcelas.map(parcela => ({
      ...parcela,
      codcompra: dadosCompra.codcompra,
      dtcompra: dadosCompra.dtcompra,
      valcompra: dadosCompra.valcompra,
      nfcompra: dadosCompra.nfcompra,
      condpag: dadosCompra.condpag,
      formapag: dadosCompra.formapag,
      fornecedor: dadosCompra.fornecedor, 
      codfor: dadosCompra.codfor,
      nomefor: dadosCompra.nomefor,
      cnpjfor: dadosCompra.cnpjfor,
      codemp: dadosCompra.codemp,
      empresa: dadosCompra.empresa,
      cnpjemp: dadosCompra.cnpjemp,
      qtdparcelas: quantidadeParcelas,
    }));

    api.post(`/apagar/${codCompra}/apagar`, dadosParcelas)
      .then(response => {
        setMensagem('Parcelas salvas com sucesso!');
        setLoading(false);
        fecharModal();
      })
      .catch(error => {
        console.error('Erro ao salvar parcelas:', error);
        setMensagem('Erro ao salvar parcelas. Tente novamente.');
        setLoading(false);
      });
  };

  const handleDelete = () => {
    if (parcelas.length === 0) {
        setMensagem(`Nenhuma parcela encontrada para o código de compra: ${codCompra}`);
        return;
    }

    setLoading(true);
    api.delete(`/apagar/codcompra/${codCompra}`)
 
      .then(response => {
        if (response.status === 204) { // No content, parcelas excluídas com sucesso
          setParcelas([]);
          setMensagem('Parcelas excluídas com sucesso.');
        } else {
          setMensagem('Erro ao excluir parcelas. Tente novamente.');
        }
        setLoading(false);
      })
      .catch(error => {
        console.error('Erro ao excluir parcelas:', error);
        setMensagem('Erro ao excluir parcelas. Tente novamente.');
        setLoading(false);
      });
  };

  const handleCloseModal = () => {
    setParcelas([]);
    setMensagem("");
    fecharModal();
  };

  // Função para lidar com a mudança do valor no input e formatar o valor
  const handleParcelaChange = (index, field, value) => {
    const updatedParcelas = [...parcelas];
    if (field === 'valparcela') {
      // Remove caracteres não numéricos, exceto ponto (.) e vírgula (,)
      let numericValue = value.replace(/[^0-9,]/g, '').replace(',', '.');
      numericValue = parseFloat(numericValue);

      updatedParcelas[index][field] = numericValue;
    } else {
      updatedParcelas[index][field] = value;
    }
    setParcelas(updatedParcelas);
  };

  const formatarValorInput = (valor) => {
    if (!valor) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  if (!isOpen) return null;

  return (
    <div className="modal">
      <div className="modal-content">

      <span className="close" onClick={handleCloseModal}>&times;</span>

      <h3 translate="no">Contas a Receber da Compra: {codCompra}</h3>
      <div className="quantidade-parcelas-container">
        <label>Quantidade de Parcelas:</label>
        <input
          type="number"
          value={quantidadeParcelas}
          onChange={(e) => setQuantidadeParcelas(parseInt(e.target.value, 10))}
          min="1"
          className="quantidade-parcelas-input"
        />
        <button
          onClick={gerarParcelas}
          disabled={parcelasExistentes.length > 0}
          className="gerar-parcelas-btn"
        >
          Gerar Parcelas
        </button>
      </div>
        
        <table>
          <thead>
            <tr>
              <th>Parcela</th>
              <th>Vencimento</th>
              <th translate="no">Valor</th>
            </tr>
          </thead>
          <tbody>
            {parcelas.map((parcela, index) => (
              <tr key={index}>
                <td>{parcela.parcela}</td>
                <td>
                  <input
                    type="date"
                    value={parcela.dtvencimento}
                    onChange={(e) => handleParcelaChange(index, 'dtvencimento', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={formatarValorInput(parcela.valparcela)}
                    onChange={(e) => handleParcelaChange(index, 'valparcela', e.target.value)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {mensagem && <p>{mensagem}</p>}
        <div className="button-container">
          <button className="excluir" onClick={handleDelete} disabled={loading}>
            {loading ? 'Excluindo...' : 'Excluir Parcelas'}
          </button>
          <button className="salvando" onClick={handleSave} disabled={parcelasExistentes.length > 0 || loading}>
            {loading ? 'Salvando...' : 'Salvar Parcelas'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalCriarParcelasCompra;